

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETCUSTOMERSBYCREATOR= createAsyncThunk(
  "getCustomersByCreator/getCustomersByCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCustomersByCreatorSlice = createSlice({
  name: "getCustomersByCreatorSlice",
  initialState: {
    getCustomersByCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCustomersByCreator: (state) => {
        state.getCustomersByCreator.loading = false
        state.getCustomersByCreator.error = false
        state.getCustomersByCreator.data = []
        state.getCustomersByCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCUSTOMERSBYCREATOR.fulfilled, (state, action) => {
      state.getCustomersByCreator = {
        ...state.getCustomersByCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERSBYCREATOR.pending, (state, action) => {
      state.getCustomersByCreator = {
        ...state.getCustomersByCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERSBYCREATOR.rejected, (state, action) => {
      state.getCustomersByCreator = {
        ...state.getCustomersByCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCustomersByCreatorAction = {
    GETCUSTOMERSBYCREATOR,
};

export { getCustomersByCreatorAction };
export default getCustomersByCreatorSlice.reducer;
export const {setInitialStateOfgetCustomersByCreator} = getCustomersByCreatorSlice.actions
